export default function makeClassAttrsEnumerable(this: any, definition: any, attrs: string[] = []) {
  for (const property of attrs) {
    const descriptor = Object.getOwnPropertyDescriptor(definition.prototype, property);
    Object.defineProperty(
      this,
      property,
      Object.assign(descriptor, {
        enumerable: true
      })
    );
  }
}
